import { css } from '@spectrum-web-components/base';
const styles = css`
    #switch:before{transition:background var(--spectrum-animation-duration-100,.13s)ease-in-out,border var(--spectrum-animation-duration-100,.13s)ease-in-out,box-shadow var(--spectrum-animation-duration-100,.13s)ease-in-out}
`;
export default styles;